import {msg} from '@lit/localize';
import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';

@customElement('arc-subscribe-button')
export class SubscribeButton extends LitElement {

	static properties = {
		size: {type: String},
	};

	constructor() {
		super();
		this.size = 'M';
	}

	render() {
		return html`
			<arc-routerlink
				route="choose-plan"
			>
				<arc-button
					title="${msg('subscribe_button')}"
					type="primary"
					size="${this.size}"
				>
				</arc-button>
			</arc-routerlink>
    `;
	}
}
